import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';
import { PlataformaTipo, tipoERP, tipoEcommerce } from '../../plataforma/tipo';
import { IntegracaoSituacao, situacaoAtiva, situacaoInativa } from '../situacao';

export class IntegracaoFilter implements Filter {
    isFilterDirty: boolean;

    situacoes: number[] = [];
    plataformaTipos: number[] = [];
    nome: string;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Situações
        this.situacoes?.forEach(situacao => {
            params = params.append('situacao', situacao.toString());
        });

        // Plataforma Tipos
        this.plataformaTipos?.forEach(plataformaTipo => {
            params = params.append('plataformaTipo', plataformaTipo.toString());
        });

        // Nome
        if (this.nome) {
            params = params.append('nome', this.nome);
        }

        return params;
    }

    /** Adiciona a situação informada ao filtro */
    private withSituacao(situacao: IntegracaoSituacao): IntegracaoFilter {
        if (!situacao) {
            return;
        }

        if (!this.situacoes) {
            this.situacoes = [];
        }
        this.situacoes.push(situacao.id);

        return this;
    }

    /** Adiciona a situação ativa ao filtro */
    withSituacaoAtiva(): IntegracaoFilter {
        return this.withSituacao(situacaoAtiva);
    }

    /** Adiciona a situação inativa ao filtro */
    withSituacaoInativa(): IntegracaoFilter {
        return this.withSituacao(situacaoInativa);
    }

    /** Adiciona o tipo da plataforma informado ao filtro */
    private withPlataformaTipo(tipo: PlataformaTipo): IntegracaoFilter {
        if (!tipo) {
            return;
        }

        if (!this.plataformaTipos) {
            this.plataformaTipos = [];
        }
        this.plataformaTipos.push(tipo.id);

        return this;
    }

    /** Adiciona o tipo da plaforma ERP ao filtro */
    withPlataformaTipoERP(): IntegracaoFilter {
        return this.withPlataformaTipo(tipoERP);
    }

    /** Adiciona o tipo da plaforma e-commerce ao filtro */
    withPlataformaTipoEcommerce(): IntegracaoFilter {
        return this.withPlataformaTipo(tipoEcommerce);
    }

    clear() {
        this.isFilterDirty = false;

        this.situacoes = [];
        this.plataformaTipos = [];
        this.nome = null;
    }
}
